import { KeyRound, XCircle } from 'lucide-react'
import { Button } from 'shared/ui/button'
import { Card, CardContent } from 'shared/ui/card'
import { Checkbox } from 'shared/ui/checkbox'

interface OpenPermitBulkActionsProps {
  isAllSelected: boolean
  selectedCount: number
  permitCount: number
  selectableCount: number
  onToggleSelectAll: (checked: boolean) => void
  onMassCancel: () => void
  onMassOpen: () => void
}

export function OpenPermitBulkActions({
  isAllSelected,
  selectedCount,
  permitCount,
  selectableCount,
  onToggleSelectAll,
  onMassCancel,
  onMassOpen,
}: OpenPermitBulkActionsProps) {
  const displayTotal = selectableCount > 0 ? selectableCount : permitCount

  return (
    <Card className="border-slate-200 shadow-sm">
      <CardContent className="flex flex-col gap-3 p-4 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-3 text-sm text-slate-600">
          <Checkbox
            checked={isAllSelected}
            disabled={selectableCount === 0}
            onCheckedChange={(checked) => onToggleSelectAll(checked === true)}
          />
          <span>เลือกทั้งหมด ({selectedCount}/{displayTotal})</span>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            className="border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700"
            disabled={selectedCount === 0}
            onClick={onMassCancel}
          >
            <XCircle className="mr-2 h-4 w-4" />
            ยกเลิกรายการ ({selectedCount})
          </Button>
          <Button
            className="bg-emerald-600 text-white hover:bg-emerald-700"
            disabled={selectedCount === 0}
            onClick={onMassOpen}
          >
            <KeyRound className="mr-2 h-4 w-4" />
            Mass Open ({selectedCount})
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
